module.exports = __webpack_public_path__ + "img/Frame 90.2db7de36.png";